import AppRouter from './lib/router/Router';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
